import './main.less';
import React from 'react';
import PropTypes from 'prop-types';

// local
import Logo from '../sidebar/logo/main';
import Menu from '../sidebar/menu/main';
import Balances from '../sidebar/balances/main';
import User from '../top/user';
import LoginAdmin from '../sidebar/login-admin/main';
import Market from '../market/main';

// shared
import RootShared from '../../../../modules/root/main';
import SmartNotification from '../../../../modules/smart-notification/main';

const RootLayoutDecorator = (RootComponent, Layout) => {
	return class Decorated extends React.Component {
		render() {
			// eslint-disable-next-line react/prop-types
			if (/market\/\d+/.test(this.props.location.pathname)) {
				// eslint-disable-next-line react/prop-types
				return <Market {...this.props} goodCardNumber={Number(/\d+/.exec(this.props.location.pathname)[0])} />;
			}
			// eslint-disable-next-line react/prop-types
			if (this.props.location.pathname.includes('market')) {
				return <Market {...this.props} />;
			}
			return <RootComponent {...this.props} layout={Layout} />;
		}
	};
};

const propTypes = {
	intl: PropTypes.func,
	children: PropTypes.element,
	userData: PropTypes.object
};

const Layout = props => (
	<div className="dashboard-layout">
		<div className="dashboard-layout__sidebar">
			<div className="dashboard-layout__sidebar--position-body">
				<Logo />
				<LoginAdmin {...props} />
				<Menu unreadMsgs={props.userData.unreadMsgs} {...props} />
				<Balances {...props} />
			</div>
			<div className="dashboard-layout__sidebar--position-footer">
				<div className="sidebar-footer">
					<p>© 2014-{new Date().getFullYear()} RocketProfit.</p>
					<p>{props.intl('Все права защищены')}</p>
				</div>
			</div>
		</div>
		<div className="dashboard-layout__body">
			<div className="dashboard-layout__body--content">
				<div className="dashboard-layout__body--content--position-top">
					<User  {...props} />
				</div>
				<div className="dashboard-layout__body--content--position-body">
					{ props.children }
				</div>
				<div className="dashboard-layout__body--content--position-footer">
					<div className="link-block font-proxima-nova-semibold">
						<a href="//rocketprofit.com/about" target="_blank">{props.intl('О компании')}</a>
						<a href="//rocketprofit.com/public_offer" target="_blank">{props.intl('Политика конфиденциальности')}</a>
						<a href="//rocketprofit.com/disclaimer" target="_blank">{props.intl('Правовая информация')}</a>
					</div>
					<div className="support-block">
						<div className="support-block__item">
							<span className="key">Skype</span>
							<a href="skype:rocketprofit.cpa?chat" className="value font-proxima-nova-semibold">rocketprofit.cpa</a>
						</div>
						<div className="support-block__item">
							<span className="key">Email</span>
							<a
								href="mailto:support@rocketprofit.com"
								className="value font-proxima-nova-semibold">support@rocketprofit.com</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<SmartNotification />
	</div>
);

Layout.propTypes = propTypes;

export default RootLayoutDecorator(RootShared, Layout);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/root/main.js